export default __webpack_public_path__ + "static/media/property_738.a57d0bef.png";